import { ProfitAndLossTableBalanceItem } from '../types/tableTypes'

export interface ProfitAndLossColumn {
  key: keyof ProfitAndLossTableBalanceItem
  label: string
  filterKey: 'showChange' | 'showGroupPercentage' | null
  alwaysShow?: boolean
}

export const PROFIT_AND_LOSS_COLUMNS: ProfitAndLossColumn[] = [
  {
    key: 'percentageChange',
    label: 'reports.profit_and_loss.change',
    filterKey: 'showChange',
  },
  {
    key: 'percentageOfType',
    label: 'reports.profit_and_loss.of_type',
    filterKey: 'showGroupPercentage',
  },
  {
    key: 'total',
    label: 'reports.profit_and_loss.total',
    filterKey: null,
    alwaysShow: true,
  },
]

export const getVisibleColumns = (showChange?: boolean, showGroupPercentage?: boolean): ProfitAndLossColumn[] =>
  PROFIT_AND_LOSS_COLUMNS.filter(({ alwaysShow, filterKey }) => {
    if (alwaysShow) {
      return true
    }
    if (filterKey === 'showChange') {
      return showChange
    }
    if (filterKey === 'showGroupPercentage') {
      return showGroupPercentage
    }
    return false
  })
